import './style.scss';
import React from 'react';
import Item from '../CardItemsCarousel/Item';
const CardItems = (props) => {
  return (
    <>
      {props?.items?.map((item, index) => {
        return (
          <div className="card-item" key={index}>
            <Item item={item} />
          </div>
        );
      })}
    </>
  );
};

export default CardItems;
